import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { MultiStyleType } from '@chakra-ui/styled-system'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { getName } from '~/utils/objectUtils'

import { PhoneComponentSizes } from './Constants'

const {
  Page: { padding: PagePadding },
} = PhoneComponentSizes

const {
  FontColor: {
    Default: DefaultFontColor,
    Error: ErrorFontColor,
    Link: LinkFontColor,
  },
} = themeColorSectionKeys.defaults

const callErrorParts = [
  'container',
  'header',
  'errorIcon',
  'headerText',
  'errorBody',
  'errorText',
  'micBody',
  'link',
  'body1',
  'h6',
  'disconnectedTitle',
] as const

const helpers = createMultiStyleConfigHelpers(callErrorParts)

export const CallErrorStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      alignSelf: 'center',
      alignItems: 'center',
      width: '600px',
      height: '480px',
      gap: '24px',
      paddingY: {
        base: PagePadding.sm.px,
        lg: PagePadding.md.px,
        xl: PagePadding.lg.px,
      },
    },
    header: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '16px',
      width: '500px',
    },
    errorIcon: {
      color: ErrorFontColor,
      boxSize: '30px',
      gap: '24px',
    },
    headerText: {
      color: ErrorFontColor,
      ...textStyles[textStyleKeys.Body1_Bold],
    },
    errorBody: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
    },
    errorText: {
      color: DefaultFontColor,
      textAlign: 'center',
    },
    micBody: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    link: {
      color: LinkFontColor,
    },
    body1: {
      ...textStyles[textStyleKeys.Body1],
    },
    h6: {
      ...textStyles[textStyleKeys.H6],
    },
    disconnectedTitle: {
      color: DefaultFontColor,
      ...textStyles[textStyleKeys.Body1_Bold],
    },
  },
  defaultProps: {},
})

export const useCallErrorStyle = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(
    getName({ CallErrorStyle }),
    props,
  ) as MultiStyleType<typeof callErrorParts>
}
